<template>
  <q-dialog
    :visible="isVisible"
    title="编辑"
    width="900px"
    :innerScroll="false"
    :showFooter="false"
    @close="onCancel"
  >
    <div class="requestParam">
      <el-table
        :data="editTableData"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
        :row-style="{ height: '35px' }"
        style="width: 100%"
        height="400px"
        ref="table"
        border
      >
        <el-table-column
          :label="item.label"
          :prop="item.prop"
          show-overflow-tooltip
          v-for="item in columnData"
          :min-width="item.width"
          :key="item.prop"
          align="center"
          :width="item.prop == 'ruleDesc' ? '220px' : ''"
        >
          <template slot-scope="scope">
            <span v-if="scope.column.label == '说明'"> {{ scope.row[item.prop] }} </span>
            <el-input
              v-if="scope.column.label == '下限' || scope.column.label == '上限'"
              autosize
              type="textarea"
              v-model="scope.row[scope.column.property]"
              size="mini"
              @input="onInput(scope)"
            />
            <el-select v-model="scope.row[scope.column.property]" filterable v-if="scope.column.label == '品类'">
              <el-option
                v-for="item in isEditMode ? optionData.category : optionData.categoryAll"
                :label="item.content"
                :key="item.content"
                :value="item.content"
              ></el-option>
            </el-select>
            <el-select v-model="scope.row.saleLocationId" filterable v-if="scope.column.label == '销售等级'">
              <el-option v-for="item in optionData.saleLocation" :label="item.content" :key="item.content" :value="item.id"></el-option>
            </el-select>
            <el-select v-model="scope.row.productTypeId" filterable v-if="scope.column.label == '产品类别'">
              <el-option v-for="item in optionData.productType" :label="item.content" :key="item.content" :value="item.id"></el-option>
            </el-select>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="dialog-footer">
      <el-button @click="onCancel">取消</el-button>
      <el-button type="primary" @click="onConfirm" :loading="loading">确认</el-button>
    </div>
  </q-dialog>
</template>

<script>
export default {
  name: 'EditTableDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    // 编辑模式传入的行数据，有值为编辑模式，无值为新增模式
    row: {
      type: Object,
      default: null
    },
    // 新增模式传入的表格数据
    tableData: {
      type: Array,
      default: () => []
    },
    optionData: {
      type: Object,
      default: () => ({})
    },
    columnData: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    isVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },
    isEditMode() {
      return !!this.row
    }
  },
  data() {
    return {
      loading: false,
      editTableData: []
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.init()
      }
    }
  },
  methods: {
    init() {
      if (this.isEditMode) {
        // 编辑模式，加载数据
        this.loadEditData()
      } else {
        // 新增模式，使用传入的表格数据
        this.editTableData = [...this.tableData]
      }
    },
    loadEditData() {
      let data = {
        category: this.row.category,
        saleLocationId: '0',
        productTypeId: '0'
      }
      this.$q.newProduct
        .assessmentRulesList({ data: data })
        .then((res) => {
          this.editTableData = res.data
        })
    },
    onCancel() {
      this.editTableData = []
      this.isVisible = false
    },
    onInput(scope) {
      let row = scope.row
      row[scope.column.property] = row[scope.column.property].replace(/[^\d]/g, '')
      
      if (!row.limitUpper && row.limitLower) {
        row.ruleDesc = `销量≥${row.limitLower || ''}`
      } else if (!row.limitLower && row.limitUpper) {
        row.ruleDesc = `销量<${row.limitUpper || ''}`
      } else if (row.limitLower && row.limitUpper) {
        row.ruleDesc = `${row.limitUpper || ''}>销量≥${row.limitLower || ''}`
      } else {
        row.ruleDesc = ''
      }

      // 上一行下限默认填充下一行上限
      if (scope.column.label == '下限' && scope.$index + 1 < this.editTableData.length && 
          scope.row.productTypeId == this.editTableData[scope.$index + 1].productTypeId) {
        let data = this.editTableData[scope.$index + 1]
        this.$set(this.editTableData[scope.$index + 1], 'limitUpper', row[scope.column.property])
        this.updateRuleDesc(data, scope.$index + 1)
      } else if (scope.column.label == '上限' && scope.$index - 1 >= 0 &&
          scope.row.productTypeId == this.editTableData[scope.$index - 1].productTypeId) {
        let data = this.editTableData[scope.$index - 1]
        this.$set(this.editTableData[scope.$index - 1], 'limitLower', row[scope.column.property])
        this.updateRuleDesc(data, scope.$index - 1)
      }
    },
    updateRuleDesc(data, index) {
      if (!data.limitUpper && data.limitLower) {
        this.$set(this.editTableData[index], 'ruleDesc', `销量≥${data.limitLower || ''}`)
      } else if (!data.limitLower && data.limitUpper) {
        this.$set(this.editTableData[index], 'ruleDesc', `销量<${data.limitUpper}`)
      } else if (data.limitLower && data.limitUpper) {
        this.$set(this.editTableData[index], 'ruleDesc', `${data.limitUpper}>销量≥${data.limitLower || ''}`)
      } else {
        this.$set(this.editTableData[index], 'ruleDesc', '')
      }
    },
    onConfirm() {
      this.loading = true
      let arr = []
      this.editTableData.forEach((v) => {
        arr.push({
          dataId: v.dataId || '',
          category: v.category,
          saleLocationId: v.saleLocationId,
          productTypeId: v.productTypeId,
          limitLower: v.limitLower,
          limitUpper: v.limitUpper,
          ruleDesc: v.ruleDesc
        })
      })
      
      const api = this.isEditMode ? 'updateAssessmentRule' : 'addAssessmentRule'
      this.$q.newProduct[api]({ data: arr })
        .then((res) => {
          if (res.code == 200) {
            this.$message.success(res.message)
            this.onCancel()
            this.$emit('success')
          } else {
            this.$message.error(res.message)
          }
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="stylus" scoped>
.dialog-footer
  text-align center
  padding 15px 0

>>> .requestParam .el-input
  width 120px
</style>
